// src/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './Constant/Auth';

// AuthProvider's mount effect synchronously validates the stored session
// (including the 48h absolute expiry) before `loading` ever flips false, so
// this never briefly renders protected content for an already-expired
// session — `user` only ever becomes truthy once that check has passed.
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <p>Checking your session…</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
